import type { ShortcutBinding, ShortcutBindingsMap, ShortcutPresetName } from 'src/stores/shortcuts/types';

import { SHORTCUT_ACTIONS } from 'src/util/shortcuts/actionsRegistry';
import { normalizeKeys } from 'src/util/shortcuts/keyNormalizer';

interface PresetBindingSeed {
	enabled: boolean;
	keys: string;
}

type PresetMap = Record<ShortcutPresetName, Record<string, PresetBindingSeed>>;

const PRESETS: PresetMap = {
	custom: {},
	minimal: {
		'app.settings.open': { enabled: true, keys: 'Mod+,' },
		'app.spotlight.toggle': { enabled: true, keys: 'Mod+K' },
	},
};

function buildBindingForAction(actionId: string, seed: PresetBindingSeed | undefined): ShortcutBinding {
	if (seed === undefined) {
		return {
			enabled: false,
			id: actionId,
			keys: '',
		};
	}

	return {
		enabled: seed.enabled,
		id: actionId,
		keys: normalizeKeys(seed.keys),
	};
}

export function buildDefaultBindings(preset: ShortcutPresetName): ShortcutBindingsMap {
	const presetSeeds = PRESETS[preset];
	const bindings: ShortcutBindingsMap = {};

	for (const action of SHORTCUT_ACTIONS) {
		bindings[action.id] = buildBindingForAction(action.id, presetSeeds[action.id]);
	}

	return bindings;
}

export function getPresetNames(): ShortcutPresetName[] {
	return ['minimal'];
}
